<section class="py-5">
    <div class="py-3 container">
        <div class="row">
            <div class="col-md-12">
                <div class="title">
                    <h1 class="fw-bold text-black">Terms & Conditions</h1>
                    <p class="py-2 fw-bold text-black">Last updated on 12<sup>th</sup> July 2025</p>
                </div>

                <div class="py-4">
                    <p class="txt-description mb-4 text-secondary">
                        Welcome to Illusbook, a digital design platform operated by Goodsketches, a registered business
                        in India. These Terms and Conditions (“Terms”) govern your access to and use of our services
                        available via the website <a class="un-link bold"
                            href="https://www.illusbook.com/">www.illusbook.com</a> By using this website, subscribing
                        to any plan, or making a payment (including via UPI), you agree to these Terms.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Business Information
                    </h2>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                            Business Name: Goodsketches
                        </li>
                        <li class="mb-3">
                            Platform Name: Illusbook
                        </li>
                        <li class="mb-3">
                            Website: <a class="un-link bold" href="https://www.illusbook.com/">www.illusbook.com</a>
                        </li>
                        <li class="mb-3">
                            Nature of Business: Digital illustration platform offering downloadable design assets
                        </li>
                        <li class="mb-3">
                            Registered Address:
                            135, Greenfield's Crown City, Phase II, Sathy Main Road,
                            Kovilpalayam, Coimbatore – 641107, Tamil Nadu, India
                        </li>
                        <li class="mb-3">
                          Contact Email: <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                        </li>
                    </ul>



                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Overview
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        Illusbook is a digital design platform offering high-quality illustrations and visual assets for
                        creative professionals, developers, startups, and product teams. Users can browse, download, and
                        subscribe to free or premium content designed to elevate digital experiences.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Eligibility
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        By using the platform, you confirm that:
                    </p>

                    <ul class="txt-description mb-5 text-secondary">
                         <li class="mb-3">
                          illusbook is open to users of all age groups. However, if you are under the age of 18, you should use this platform under the supervision of a parent or guardian, especially when making purchases or subscribing to paid plans.
                        </li>
                        <li class="mb-3">
                            You have the legal authority to agree to these Terms.
                        </li>
                        <li class="mb-3">
                            You are not barred under applicable laws from using our services.
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        User Accounts
                    </h2>

                    <p class="txt-description mb-4 text-secondary">To access premium features, you may need to create an
                        account:</p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                           You must provide accurate and up-to-date information during registration.
                        </li>
                        <li class="mb-3">
                            You are responsible for keeping your login credentials secure.
                        </li>
                        <li class="mb-3">
                           We reserve the right to suspend accounts for misuse or policy violations.
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                       Subscription Plans & Payments
                    </h2>

                    <p class="txt-description mb-4 text-secondary">Illusbook offers Free and Premium subscription plans:
                    </p>

                    <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                            Free users can download PNG versions of free illustrations.
                        </li>
                        <li class="mb-3">
                            Premium users gain access to all available formats (PNG, SVG, JPG, AI, EPS).
                        </li>
                        <li class="mb-3">
                            Subscription fees are billed as per your selected plan via a secure payment gateway.
                        </li>
                    </ul>

                      <h3 class="txt-title fs-4 mb-4 text-black">
                       Payment Terms:
                    </h3>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                           Payments can be made via Razorpay using cards, UPI, net banking, or wallets.
                        </li>
                        <li class="mb-3">
                          All prices are inclusive of applicable taxes unless stated otherwise.
                        </li>
                        <li class="mb-3">
                            By subscribing, you authorize us to charge you based on the selected plan and billing cycle.
                        </li>
                    </ul>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                        Refund & Cancellation Policy
                    </h2>

                     <ul class="txt-description mb-3 text-secondary">
                        <li class="mb-3">
                          Due to the nature of digital products, all sales are final and non-refundable.
                        </li>
                        <li class="mb-3">
                         We do not provide partial, prorated, or mid-cycle refunds.
                        </li>
                        <li class="mb-3">
                           If you experience duplicate charges or payment errors, email us within 3 working days at  <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                        </li>
                    </ul>


                    <p class="txt-description mb-5 text-secondary">For full details, refer to <a target="_blank"
                            class="un-link bold" routerLink="/refund">our
                            Refund Policy</a>.</p>

                             <h2 class="txt-title fs-4 mb-4 text-black">
                       UPI Payments & Chargebacks
                    </h2>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                      UPI transactions are processed through Razorpay's secure payment gateway.
                        </li>
                        <li class="mb-3">
                          For failed UPI transactions, please contact us at <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a> within 72 hours.
                        </li>
                        <li class="mb-3">
                       Chargebacks must be initiated only after contacting our support for resolution.
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Licensing & Usage
                    </h2>

                    <p class="txt-description mb-4 text-secondary">All assets on Illusbook are licensed for use, not
                        sold:</p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                            You receive a non-exclusive, non-transferable license to use assets for personal or
                            commercial use
                        </li>
                        <li class="mb-3">
                            Redistribution, resale, or uploading assets to other platforms is strictly prohibited.
                        </li>
                        <li class="mb-3">
                            Assets cannot be used for unlawful, harmful, or deceptive content.
                        </li>
                        <li class="mb-3">
                           Attribution is appreciated but not required.
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Prohibited Activities
                    </h2>

                    <p class="txt-description mb-4 text-secondary">You may not:</p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                            Share premium files with non-subscribers
                        </li>
                        <li class="mb-3">
                            Use automated bots to scrape or download content
                        </li>
                        <li class="mb-3">
                           Use assets in illegal, defamatory, or misleading content
                        </li>
                        <li class="mb-3">
                           Copy or reproduce website elements, including design or code
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Intellectual Property
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        All content, illustrations, site design, branding, and features of Illusbook are the intellectual
                        property of Goodsketches Company. Unauthorized copying or reproduction is
                        prohibited and may result in legal action.
                    </p>

                

                    <h2 class="txt-title fs-4 mb-4 text-black">
                       Service Changes & Modifications
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        We reserve the right to:
                    </p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                           Modify or discontinue parts of the service at any time
                        </li>
                        <li class="mb-3">
                            Update subscription pricing or plan offerings
                        </li>
                        <li class="mb-3">
                            Amend these Terms with or without notice
                        </li>
                    </ul>

                    <p class="txt-description mb-4 text-secondary">
                        Continued use after updates constitutes acceptance.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Limitation of Liability
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                      Illusbook is provided “as is.” We are not liable for:
                    </p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                           Temporary service outages or errors in content
                        </li>
                        <li class="mb-3">
                            Financial loss due to misuse or unauthorized access
                        </li>
                        <li class="mb-3">
                           Failures of third-party services (e.g., Razorpay, UPI providers)
                        </li>
                    </ul>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Privacy Policy
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        We respect your privacy. Your personal data is collected and handled according to <a
                            class="un-link bold" routerLink="/privacy">our Privacy Policy</a>. We do not sell your data
                        to third parties.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Governing Law
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        These Terms are governed by and construed under the laws of India. Any disputes shall be
                        resolved exclusively in the courts of Coimbatore, Tamil Nadu, India.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Contact
                    </h2>

                    <p class="txt-description mb-4 text-secondary">
                        If you have any questions regarding these Terms, feel free to reach us:
                        <a class="un-link bold" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>

                        <br> <br>

                        <strong class="bold">Goodsketches</strong>, <br>
                        135, Greenfield's Crown City, Phase II, Sathy Main Road, Kovilpalayam, <br>
                        Coimbatore - 641107 Tamil Nadu,<br>
                        India.


                    </p>
                </div>
            </div>
        </div>
    </div>
</section>